import * as React from "react"
import type { SVGProps } from "react"
const SvgUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 20.57q-.82 0-1.41-.59A2 2 0 0 1 4 18.57v-2q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v2h12v-2q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v2q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm5-12.15L9.13 10.3a1 1 0 0 1-.72.28 1 1 0 0 1-.71-.3q-.27-.3-.29-.7a1 1 0 0 1 .29-.7l3.6-3.6q.14-.15.33-.22a1 1 0 0 1 .74 0 1 1 0 0 1 .33.21l3.6 3.6q.3.3.29.7a1 1 0 0 1-1 1.01 1 1 0 0 1-.72-.28L13 8.42v7.15q0 .42-.29.71a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7z" />
  </svg>
)
export default SvgUpload
